import React, { useEffect, useState } from 'react';
import RibbonFriends from '@assets/images/app/ribbon-friends.png';
import RibbonKakao from '@assets/images/app/ribbon-kakao.png';
import RibbonMarketing from '@assets/images/app/ribbon-marketing.png';

export const BenefitsBanner: React.FC = () => {
  const [current, setCurrent] = useState(0);

  const banners = [
    {
      image: RibbonFriends,
      onClick: () => {},
    },
    {
      image: RibbonKakao,
      onClick: () => {},
    },
    {
      image: RibbonMarketing,
      onClick: () => {},
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 2500); // 2.5 seconds per slide
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        width: '100%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '12px',
      }}>
      <button className="link-button" onClick={banners[current].onClick}>
        <img
          src={banners[current].image}
          alt={`Banner${current}`}
          style={{ width: '100%', transition: 'opacity 0.5s', objectFit: 'contain', borderRadius: '8px' }}
        />
      </button>
    </div>
  );
};
